/* Lumivé — interacciones propias (prefijo mt-). Vanilla, sin librerías. */
(function () {
  if (window.__mtLoaded) return; window.__mtLoaded = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Partir titulares en palabras para la entrada escalonada */
  function initSplit(root) {
    root.querySelectorAll('[data-mt-split]:not([data-split-done])').forEach(function (el) {
      el.setAttribute('data-split-done', '');
      var i = 0;
      function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'mt-w';
              var s = document.createElement('span'); s.textContent = part; s.style.setProperty('--i', i++);
              w.appendChild(s); frag.appendChild(w);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1 && child.tagName !== 'BR') {
            // Palabras destacadas (<em>): se envuelven enteras
            var w2 = document.createElement('span'); w2.className = 'mt-w';
            var s2 = document.createElement('span'); s2.style.setProperty('--i', i++);
            child.parentNode.replaceChild(w2, child); s2.appendChild(child); w2.appendChild(s2);
          }
        });
      }
      walk(el);
      el.classList.add('mt-split');
    });
  }

  /* Un solo observador para todas las entradas */
  var io = null;
  function initReveal(root) {
    var els = root.querySelectorAll('.mt-reveal, .mt-mask, .mt-split, [data-mt-count]');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); if (el.hasAttribute('data-mt-count')) countUp(el, true); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('mt-visible');
          if (e.target.hasAttribute('data-mt-count')) countUp(e.target);
          io.unobserve(e.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* Cifras que cuentan hacia arriba */
  function countUp(el, instant) {
    var target = parseFloat(el.getAttribute('data-mt-count')) || 0;
    var dec = (el.getAttribute('data-mt-count').split('.')[1] || '').length;
    var dur = parseInt(el.getAttribute('data-mt-duration') || '1800', 10);
    if (instant) { el.textContent = target.toFixed(dec); return; }
    var t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = (target * eased).toFixed(dec);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* Parallax suave y progreso de la línea de pasos */
  var parallaxEls = [], lines = [];
  function initScrollFx(root) {
    root.querySelectorAll('[data-mt-parallax]').forEach(function (el) { parallaxEls.push(el); });
    root.querySelectorAll('.mt-steps__line').forEach(function (el) { lines.push(el); });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-mt-parallax')) || 0;
        var center = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (center * k * -1).toFixed(1) + 'px,0)';
      });
      lines.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        var p = Math.min(Math.max((vh * 0.85 - r.top) / (r.height * 0.6), 0), 1);
        el.style.setProperty('--p', p.toFixed(3));
      });
      ticking = false;
    });
  }

  /* Brillo que sigue al cursor en botones y tarjetas + inclinación 3D */
  function initPointer(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    root.querySelectorAll('.mt-btn, .mt-tile').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = e.clientX - r.left, y = e.clientY - r.top;
        el.style.setProperty('--mx', x + 'px'); el.style.setProperty('--my', y + 'px');
        if (el.classList.contains('mt-tile') && el.hasAttribute('data-mt-tilt')) {
          var rx = ((y / r.height) - 0.5) * -5, ry = ((x / r.width) - 0.5) * 6;
          el.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
        }
      });
      el.addEventListener('pointerleave', function () { if (el.classList.contains('mt-tile')) el.style.transform = ''; });
    });
  }

  /* Acordeones (FAQ y detalles de producto) */
  function initAccordions(root) {
    root.querySelectorAll('.mt-acc__q').forEach(function (btn) {
      if (btn.dataset.ready) return; btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.mt-acc__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && btn.closest('[data-mt-single]')) {
          btn.closest('[data-mt-single]').querySelectorAll('.mt-acc__item.is-open').forEach(function (o) {
            if (o !== item) { o.classList.remove('is-open'); o.querySelector('.mt-acc__q').setAttribute('aria-expanded', 'false'); }
          });
        }
      });
    });
  }

  /* Página de producto: galería, cantidad, variantes, barra fija */
  function initProduct(root) {
    root.querySelectorAll('[data-mt-pdp]').forEach(function (pdp) {
      if (pdp.dataset.ready) return; pdp.dataset.ready = '1';
      var slides = pdp.querySelectorAll('.mt-pdp__main img');
      var thumbs = pdp.querySelectorAll('.mt-pdp__thumb');
      var current = 0;
      function go(n) {
        if (!slides.length) return;
        current = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
        // Lleva la miniatura activa a la vista dentro de su fila (sin mover la página)
        var at = thumbs[current], row = at && at.parentElement;
        if (row && row.scrollWidth > row.clientWidth) {
          var rr = row.getBoundingClientRect(), ar = at.getBoundingClientRect();
          var left = row.scrollLeft + (ar.left - rr.left) - (rr.width - ar.width) / 2;
          row.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var prev = pdp.querySelector('[data-mt-prev]'), next = pdp.querySelector('[data-mt-next]');
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      var main = pdp.querySelector('.mt-pdp__main'), sx = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1)); sx = null; });
      }

      var qty = pdp.querySelector('.mt-qty input');
      pdp.querySelectorAll('[data-mt-qty]').forEach(function (b) {
        b.addEventListener('click', function () { var v = parseInt(qty.value, 10) || 1; qty.value = Math.max(1, v + parseInt(b.dataset.mtQty, 10)); });
      });

      var dataEl = pdp.querySelector('[data-mt-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = pdp.querySelector('input[name="id"]');
      var priceEl = pdp.querySelector('[data-mt-price]'), compareEl = pdp.querySelector('[data-mt-compare]');
      var btn = pdp.querySelector('[data-mt-add]'), btnLabel = btn ? btn.querySelector('[data-mt-add-label]') : null;
      var fmt = pdp.getAttribute('data-money-format') || '{{amount}}';
      function money(cents) {
        var v = (cents / 100).toFixed(2);
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
          if (k.indexOf('comma') > -1) return v.replace('.', ',');
          if (k.indexOf('no_decimals') > -1) return Math.round(cents / 100);
          return v;
        });
      }
      pdp.querySelectorAll('[data-mt-option]').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = [];
          pdp.querySelectorAll('[data-mt-option-group]').forEach(function (g) { var c = g.querySelector('input:checked'); sel.push(c ? c.value : null); });
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) { if (btn) btn.disabled = true; if (btnLabel) btnLabel.textContent = btn.dataset.unavailable; return; }
          idInput.value = v.id;
          if (priceEl) priceEl.textContent = money(v.price);
          if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
          if (btn) { btn.disabled = !v.available; if (btnLabel) btnLabel.textContent = v.available ? btn.dataset.add : btn.dataset.soldout; }
          if (v.featured_media) {
            var idx = Array.prototype.findIndex.call(slides, function (s) { return s.dataset.mediaId == v.featured_media.id; });
            if (idx > -1) go(idx);
          }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        });
      });

      // Selector Lumivé / Duo: fija la cantidad (1 o 2) y el texto del botón
      var pack = pdp.querySelector('[data-mt-pack]'), packQty = pdp.querySelector('[data-mt-pack-qty]');
      if (pack && packQty) {
        pack.querySelectorAll('input[name="mt-pack"]').forEach(function (r) {
          r.addEventListener('change', function () {
            packQty.value = r.value;
            if (btnLabel && btn && !btn.disabled) btnLabel.textContent = r.dataset.label;
            if (btn) btn.dataset.add = r.dataset.label;
          });
        });
      }

      var sticky = document.querySelector('[data-mt-sticky-buy]'), form = pdp.querySelector('form[action*="/cart/add"]');
      if (sticky && form && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(form);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { var b = form.querySelector('[type=submit]'); if (b && !b.disabled) b.click(); });
      }
    });
  }

  /* Carrito de cristal: añadir sin salir de la página y abrir el carrito lateral */
  function initAjaxCart(root) {
    if (!document.querySelector('cart-drawer')) return;
    root.querySelectorAll('[data-mt-pdp] form[action*="/cart/add"], .mt-cta form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.mtAjax) return; form.dataset.mtAjax = '1';
      form.addEventListener('submit', function (e) {
        // El carrito lateral de Shopify se carga después que este archivo: se comprueba al pulsar
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return;
        e.preventDefault();
        var btn = form.querySelector('[type=submit]');
        if (btn) { btn.disabled = true; btn.style.opacity = '.7'; }
        var fd = new FormData(form);
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              var err = form.parentElement.querySelector('.mt-pdp__error');
              if (!err) { err = document.createElement('p'); err.className = 'mt-pdp__error'; form.after(err); }
              err.textContent = res.description || res.message;
              return;
            }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) { btn.disabled = false; btn.style.opacity = ''; } });
      });
    });
  }

  /* Detalles del carrito de cristal: brillo del botón, garantías y reflejo que sigue al cursor */
  function decorateDrawer() {
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (!inner) return;
    var btn = inner.querySelector('.cart__checkout-button');
    if (btn && !btn.querySelector('.mt-sheen')) {
      var s = document.createElement('span'); s.className = 'mt-sheen'; s.setAttribute('aria-hidden', 'true'); btn.prepend(s);
    }
    var ctas = inner.querySelector('.cart__ctas');
    if (ctas && !inner.querySelector('.mt-cart-assure')) {
      var a = document.createElement('div'); a.className = 'mt-cart-assure';
      a.innerHTML = '<span>Free US shipping</span><span>14-day returns</span><span>Secure checkout</span>';
      ctas.after(a);
    }
  }
  function initGlassDrawer() {
    var host = document.getElementById('CartDrawer');
    if (!host || host.dataset.mtGlass) return; host.dataset.mtGlass = '1';
    decorateDrawer();
    new MutationObserver(decorateDrawer).observe(host, { childList: true, subtree: true });
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    host.addEventListener('pointermove', function (e) {
      var inner = host.querySelector('.drawer__inner'); if (!inner) return;
      var r = inner.getBoundingClientRect();
      inner.style.setProperty('--gx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      inner.style.setProperty('--gy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    });
  }

  /* Newsletter emergente: una vez por visitante (se recuerda en el navegador) */
  function initNewsletter() {
    var el = document.querySelector('[data-mt-newsletter]');
    if (!el || el.dataset.ready) return; el.dataset.ready = '1';
    var KEY = 'mtNewsletterHideUntil';
    function store(v) { try { localStorage.setItem(KEY, String(v)); } catch (e) {} }
    function hiddenByUser() { try { return Number(localStorage.getItem(KEY) || 0) > Date.now(); } catch (e) { return false; } }
    var lastFocus = null;
    function open() {
      if (!el.hidden) return;
      lastFocus = document.activeElement;
      el.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
      var input = el.querySelector('input[type=email]');
      setTimeout(function () { (input || el.querySelector('.mt-nl__close')).focus({ preventScroll: true }); }, 450);
    }
    function close() {
      el.classList.remove('is-open');
      setTimeout(function () { el.hidden = true; if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }, 500);
      if (!el.querySelector('[data-mt-nl-success]')) store(Date.now() + (parseInt(el.dataset.days, 10) || 14) * 864e5);
    }
    el.querySelectorAll('[data-mt-nl-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });
    var form = el.querySelector('form');
    if (form) form.addEventListener('submit', function () { store(Date.now() + 3650 * 864e5); });

    // Tras enviar el formulario la página se recarga: mostrar el resultado (éxito o error) al instante
    var posted = el.querySelector('[data-mt-nl-success], .mt-nl__error');
    if (posted) { store(Date.now() + 3650 * 864e5); if (el.querySelector('.mt-nl__error')) store(0); open(); return; }
    if (window.Shopify && window.Shopify.designMode) return; // en el editor no molesta: se ve al seleccionar la sección
    if (hiddenByUser()) return;
    setTimeout(open, (parseInt(el.dataset.delay, 10) || 0) * 1000);
  }
  document.addEventListener('shopify:section:select', function (e) {
    var el = e.target.querySelector && e.target.querySelector('[data-mt-newsletter]');
    if (el) { el.hidden = false; el.classList.add('is-open'); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var el = e.target.querySelector && e.target.querySelector('[data-mt-newsletter]');
    if (el) { el.classList.remove('is-open'); el.hidden = true; }
  });

  /* Comparador antes/después: arrastrar con ratón o dedo, flechas del teclado y una pequeña demo al aparecer */
  function initCompare(root) {
    root.querySelectorAll('[data-mt-ba]').forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var range = box.querySelector('.mt-ba__range');
      if (!range) return;
      var pos = parseFloat(range.value) || 50, dragging = false, demo = null;
      function set(v) { pos = Math.max(0, Math.min(100, v)); box.style.setProperty('--pos', pos + '%'); range.value = pos; }
      function fromEvent(e) { var r = box.getBoundingClientRect(); return (e.clientX - r.left) / r.width * 100; }
      function stopDemo() { if (demo) { cancelAnimationFrame(demo); demo = null; } box.classList.add('was-used'); }
      box.addEventListener('pointerdown', function (e) {
        stopDemo(); dragging = true; box.classList.add('is-dragging'); set(fromEvent(e));
        if (box.setPointerCapture) box.setPointerCapture(e.pointerId);
      });
      box.addEventListener('pointermove', function (e) { if (dragging) set(fromEvent(e)); });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
        box.addEventListener(t, function () { dragging = false; box.classList.remove('is-dragging'); });
      });
      range.addEventListener('input', function () { stopDemo(); set(parseFloat(range.value)); });
      set(pos);
      if (reduce || !('IntersectionObserver' in window)) return;
      var start = pos;
      var io2 = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io2.disconnect();
        var t0 = null;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / 2600, 1);
          set(start + Math.sin(p * Math.PI * 2) * 22 * (1 - p));
          if (p < 1) demo = requestAnimationFrame(step); else demo = null;
        }
        setTimeout(function () { if (!box.classList.contains('was-used')) demo = requestAnimationFrame(step); }, 700);
      }, { threshold: 0.5 });
      io2.observe(box);
    });
  }

  function init(root) {
    root = root || document;
    // Cada pieza aislada: si una falla, las demás (y las animaciones de entrada) siguen funcionando
    [function () { initSplit(root); }, function () { initReveal(root); }, function () { initNewsletter(); }, function () { initCompare(root); },
     function () { initScrollFx(root); }, function () { initPointer(root); }, function () { initAccordions(root); }, function () { initProduct(root); },
     function () { initAjaxCart(root); }, function () { initGlassDrawer(); }].forEach(function (fn) {
      try { fn(); } catch (err) { if (window.console) console.warn("[mt] ", err); }
    });
    onScroll();
    window.__mtReady = true;
    // Respaldo: si en 2,5 s el observador no ha mostrado lo que ya está en pantalla, se muestra igualmente
    setTimeout(function () {
      if (document.hidden) return;
      document.querySelectorAll(".mt-reveal:not(.mt-visible), .mt-mask:not(.mt-visible), .mt-split:not(.mt-visible)").forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add("mt-visible");
      });
    }, 2500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // Editor de Shopify: re-inicializar al editar una sección
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
